export function DangerEmpty({ className = '' }: Readonly<{ className?: string }>) {
  return (
    <span className={`icon ${className}`}>
      <svg
        width="200"
        height="122"
        viewBox="0 0 200 122"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M105.9 28.7001C101.966 20.2334 98.033 20.2334 94.0996 28.7001L49.8996 103.3C45.9663 111.767 48.6663 116 57.9996 116C57.9996 116 132.666 116 142 116C151.333 116 154.033 111.767 150.1 103.3L105.9 28.7001Z"
          fill="var(--clr-container-bg)"
          stroke="var(--clr-border-grey-100)"
        />
        <path
          d="M84 76C88 80.6667 92 80.6667 96 76"
          stroke="var(--clr-general-description)"
          strokeLinecap="round"
        />
        <path
          d="M104 76C108 80.6667 112 80.6667 116 76"
          stroke="var(--clr-general-description)"
          strokeLinecap="round"
        />
        <path
          d="M92 90C97.3333 94 102.667 94 108 90"
          stroke="var(--clr-general-description)"
          strokeLinecap="round"
        />
        <path
          opacity="0.18"
          d="M78.5 88.5C80.1569 88.5 81.5 87.1569 81.5 85.5C81.5 83.8431 80.1569 82.5 78.5 82.5C76.8431 82.5 75.5 83.8431 75.5 85.5C75.5 87.1569 76.8431 88.5 78.5 88.5Z"
          fill="var(--clr-general-primary)"
        />
        <path
          opacity="0.18"
          d="M118.5 88.5C120.157 88.5 121.5 87.1569 121.5 85.5C121.5 83.8431 120.157 82.5 118.5 82.5C116.843 82.5 115.5 83.8431 115.5 85.5C115.5 87.1569 116.843 88.5 118.5 88.5Z"
          fill="var(--clr-general-primary)"
        />
        <path
          d="M132.784 25.2237C126.96 31.6419 124.254 39.0887 124.665 47.564"
          stroke="var(--clr-title)"
          strokeOpacity="0.2"
          strokeWidth="2.4"
          strokeLinecap="round"
          strokeDasharray="1 7"
        />
        <path
          opacity="0.9"
          d="M135.335 19.4363C139.106 13.2898 145.392 12.5909 148.815 17.6193C144.205 21.95 138.827 22.2298 135.335 19.4363Z"
          fill="var(--clr-general-primary)"
        />
        <path
          opacity="0.65"
          d="M135.335 19.4361C131.004 14.8268 132.54 8.61068 137.988 6.0959C140.502 11.5435 139.455 16.4326 135.335 19.4361Z"
          fill="var(--clr-general-primary)"
        />
        <path
          opacity="0.45"
          d="M38 70L40 75L45 77L40 79L38 84L36 79L31 77L36 75L38 70Z"
          fill="var(--clr-general-primary)"
        />
        <path
          opacity="0.4"
          d="M61.0004 26.5999C62.4363 26.5999 63.6004 25.4358 63.6004 23.9999C63.6004 22.564 62.4363 21.3999 61.0004 21.3999C59.5644 21.3999 58.4004 22.564 58.4004 23.9999C58.4004 25.4358 59.5644 26.5999 61.0004 26.5999Z"
          fill="var(--clr-general-primary)"
        />
      </svg>
    </span>
  );
}
